// src/components/ColumnMapper.jsx
import React from "react";
import { MdSwapHoriz } from "react-icons/md";

const ColumnMapper = ({ dbField, csvColumns, selected, onChange }) => {
  return (
    <div
      className="
        p-4 border rounded-lg mb-3 bg-white shadow-sm 
        flex flex-col md:flex-row 
        md:items-center md:justify-between 
        gap-4
      "
    >
      {/* DB Field Name */}
      <div className="w-full md:w-1/3">
        <div className="text-sm text-gray-500">Database Field</div>
        <div className="text-lg font-semibold break-words">{dbField.label}</div>
      </div>

      {/* Icon */}
      <div className="flex justify-center w-full md:w-auto">
        <MdSwapHoriz className="text-3xl text-sky-600" />
      </div>

      {/* Dropdown */}
      <div className="w-full md:w-1/3">
        <div className="text-sm text-gray-500">Map From CSV</div>
        <select
          className="border p-2 rounded-lg bg-gray-50 w-full"
          value={selected}
          onChange={(e) => onChange(dbField.value, e.target.value)}
        >
          <option value="">-- Select CSV Column --</option>

          {csvColumns.map((col) => (
            <option key={col} value={col}>
              {col}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ColumnMapper;
